import React from "react";
import { TdSkeleton, Th } from ".";
import { TableSkeletonProps } from "../interfaces";

export const TableSkeleton: React.FC<TableSkeletonProps> = (props) => {
  const { columns, minRowHeight, shouldCenterRowContent, title, withSelection } = props;

  return (
    <div className="mx-auto flex w-full flex-col gap-5 overflow-auto">
      <div className="mx-auto w-full overflow-auto rounded-2xl border border-gray-200 text-sm text-black">
        <table className="w-full border-collapse">
          {title && (
            <thead className="bg-white">
              <tr className="flex min-h-[4rem] w-full border-b border-gray-200">
                <th className="flex flex-1 items-center justify-start px-4 py-3 text-lg font-bold text-gray-900">
                  {title}
                </th>
              </tr>
            </thead>
          )}
          <thead className="bg-gray-50">
            <tr className="flex min-h-[3rem] w-full border-b border-gray-200">
              {columns.map((column) => (
                <Th
                  key={column.firstFieldKey}
                  align={column.align}
                  firstFieldKey={column.firstFieldKey}
                  hasSorting={column.hasSorting}
                  isCut={column.isCut}
                  minWidth={column.minWidth}
                  secondFieldKey={column.secondFieldKey}
                  sortKey={column.sortKey}
                  title={column.title}
                  weight={column.weight}
                />
              ))}
              {withSelection && (
                <Th
                  isCheckbox
                  isDisabled
                  minWidth={60}
                  weight={0}
                />
              )}
            </tr>
          </thead>
          <tbody>
            {Array(10)
              .fill(null)
              .map((_, index) => (
                <tr
                  key={`skeleton-${index}`}
                  className={`flex w-full border-b border-gray-200 bg-white last:border-b-0 ${
                    shouldCenterRowContent ? "items-center" : ""
                  }`}
                  style={{
                    minHeight: minRowHeight ? `${minRowHeight}px` : "48px",
                  }}
                >
                  {columns.map((column) => (
                    <TdSkeleton
                      key={`${index}-${column.firstFieldKey}`}
                      align={column.align}
                      firstFieldType={column.firstFieldType}
                      isFirstFieldSubtitle={column.isFirstFieldSubtitle}
                      isSecondFieldSubtitle={column.isSecondFieldSubtitle}
                      minWidth={column.minWidth}
                      secondFieldKey={column.secondFieldKey}
                      secondFieldType={column.secondFieldType}
                      weight={column.weight}
                    />
                  ))}
                  {withSelection && (
                    <td
                      className="flex-1 p-4 text-center"
                      style={{ minWidth: "60px", flex: 0 }}
                    >
                      <div className="mx-auto h-5 w-5 animate-pulse rounded bg-gray-200" />
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
